<template>
	<div>
		<SOSlotBase :bg-white="true" :loading="pageSetting.loading">
			<template v-slot:loading-page>
				<SOLoadingPage/>
			</template>

			<template v-slot:title-bar>
				<SOTitleBar
					:page-title="'Nota Tambahan'"
					:type="'back'"
					@back="back"
				/>
			</template>

			<template v-slot:content>
				<div v-if="false">
					<div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom">
						<img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
						<div class="d-block">
							<div class="f-regular f-14 f-c-black">
								Nota ini butuh konfirmasi penghapusan
							</div>
							<div class="f-regular f-12 f-c-midgrey">
								Lakukan konfirmasi di halaman pembatalan
							</div>
						</div>
					</div>
					<div class="bg-yellow p-x-20 p-y-8 d-flex flex-column justify-content-start border-bottom">
						<SOTextEllipsis
							:line-numbers="3"
							:text-label="'Keterangan:'"
							:text-content="'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut deserunt error nam necessitatibus numquam officia quos similique voluptates! A amet aspernatur deserunt dolorum est illo minima nostrum ut vero voluptatibus.'"
						/>
					</div>
					<div class="bg-yellow p-x-20 p-y-8 f-regular f-12 f-c-midgrey border-bottom">
						Lakukan konfirmasi melalui tombol di bawah.
					</div>
				</div>

				<div class="p-x-20 p-y-20">
					<div class="f-bold f-16 f-c-black">{{ idantarextra }}</div>
					<div class="f-regular f-14 f-c-midgrey">
						Bagian dari nota {{ detail.data.idtransaksi }}
					</div>
					<div class="f-regular f-14 f-c-midgrey">
						Dibuat oleh {{ detail.data.karyawan }}
					</div>
				</div>

				<div class="separator"></div>

				<div class="p-x-20 p-y-20">
					<div class="f-bold f-16 f-c-black">
						Perubahan Pengantaran
					</div>
					<div class="m-t-16">
						<div class="f-regular f-14 f-c-midgrey">
							Alamat Sebelumnya
						</div>
						<div class="f-regular f-14 f-c-black m-d-12">
							{{ detail.data.alamat_lama }}
						</div>

						<div class="separator-line m-d-12"></div>

						<div class="f-regular f-14 f-c-midgrey">
							Alamat Baru
						</div>
						<div class="f-regular f-14 f-c-black m-d-12">
							{{ detail.data.alamat_baru }}
						</div>
					</div>
				</div>

				<div class="p-x-16 p-y-20 bg-grey">
					<SOTransaksiDetailTagihan
						class="m-d-20"
						:transaksi="detailTransaksi.data"
						:tagihan-tambahan="true"
					/>
				</div>

				<div class="p-x-20 p-y-20" v-if="true">
					<SOButton
						:text="'Hapus Tagihan'"
						:outline-danger="true"
						:full="true"
						@action="() => { pageSetting.modal.deleteTransaksi = true }"
					/>
				</div>

				<div
					v-if="false"
					class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
					style="position: fixed; bottom: 64px"
				>
					<div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
						<SOButton
							:outline="true"
							:full="true"
							:text="'Tolak'"
						/>
					</div>
					<div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
						<SOButton
							:primary="true"
							:full="true"
							:text="'Setujui'"
						/>
					</div>
				</div>
			</template>

			<template v-slot:modal>
				<TransaksiModalHapus
					v-if="pageSetting.modal.deleteTransaksi"
					:is-antar-extra="true"
					:transaksi="detail.data"
					@close="() => { pageSetting.modal.deleteTransaksi = false }"
				/>
			</template>
		</SOSlotBase>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTransaksiDetailTagihan from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailTagihan";
import SOButton from "@/so-components/global/ui/SOButton";
import TransaksiModalHapus from "./modal/TransaksiModalHapus";

import SOTextEllipsis from "@/so-components/global/ui/SOTextEllipsis";

export default {
	name: "TransaksiNotaTambahan",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,
		SOTransaksiDetailTagihan,
		SOButton,
		TransaksiModalHapus,

		SOTextEllipsis,
	},
	computed: {
		...mapGetters("transaksiModule", {
			detail: "getDetailPengantaranExtra",
			detailTransaksi: "getDetailTransaksi",
		})
	},
	data() {
		return {
			idantarextra: "",

			pageSetting: {
				loading: false,
				modal: {
					deleteTransaksi: false,
				}
			}
		}
	},
	async mounted() {
		this.idantarextra = this.$route.params.idantarextra
		await this.getDetail()
		await this.getDetailTransaksi()
	},
	methods: {
		back() {
			this.$router.back()
			// this.$router.push("/konsumen/detail/transaksi/detail/" + this.idtransaksi)
		},
		async getDetail() {
			const res = await this.$store.dispatch("transaksiModule/fetchDetailDataPengantaranExtra", this.idantarextra)
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
			}
		},
		async getDetailTransaksi() {
			const res = await this.$store.dispatch("transaksiModule/fetchDetailTransaksi", this.detail.data.idtransaksi)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
			}
		},
	},
	beforeDestroy() {
		this.$store.commit("transaksiModule/resetDetailTransaksi")
		this.$store.commit("transaksiModule/resetDetailPengantaranExtra")
	}
}
</script>